(function () {
  if (window.__cfMarquee) return;
  window.__cfMarquee = true;
  function kick() {
    var tracks = document.querySelectorAll('.cfm__track');
    for (var i = 0; i < tracks.length; i++) {
      var el = tracks[i];
      if (!el.getAnimations) continue;
      var list = [];
      try { list = el.getAnimations(); } catch (e) { continue; }
      for (var j = 0; j < list.length; j++) {
        try {
          if (list[j].playbackRate !== 1) list[j].playbackRate = 1;
          if (list[j].playState !== 'running') list[j].play();
        } catch (e) {}
      }
    }
  }
  var evs = ['pageshow', 'visibilitychange', 'focus', 'pointerdown', 'touchstart', 'resize'];
  for (var i = 0; i < evs.length; i++) window.addEventListener(evs[i], kick, { passive: true, capture: true });
  document.addEventListener('DOMContentLoaded', kick);
  window.setInterval(kick, 700);
  kick();
})();